import { useContext } from 'react';
import { Context } from './Context';
export const useFileSystemAccessDrawer = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useFileSystemAccessDrawer hook used outside <FileSystemAccessDrawerProvider />');
    }
    return context;
};
